module.exports = __webpack_public_path__ + "img/about-top-bg.798935e3.png";